import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-12 md:py-16 lg:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-medium mb-3">
            <i className="ri-mail-send-line"></i>
            <span>联系与投稿</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            读者投稿与联系
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            {contactData.description}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4">
            {contactData.methods.map((method, idx) => (
              <div
                key={idx}
                className="flex items-start gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 transition-all"
              >
                <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                  <i className={`${
                    idx === 0 ? 'ri-book-2-line' :
                    idx === 1 ? 'ri-translate-2' :
                    idx === 2 ? 'ri-bug-line' :
                    'ri-briefcase-line'
                  } text-primary-600 text-lg md:text-xl`}></i>
                </div>
                <div>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">
                    {method.label}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {method.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 md:mt-8 text-center">
            <a
              href="#faq"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-questionnaire-line"></i>
              查看更多常见问题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}